export default "__VITE_ASSET__TorbQdgL__"